export const phoneRegex = "^(\\+[0-9]{2}[ ]?)?[0-9]{2}[ ]?[0-9]{2}[ ]?[0-9]{2}[ ]?[0-9]{2}[ ]?$";

export const zipRegex = "^[0-9]{4}$";

export const eanRegex = "^[0-9]{13}$";

export const cvrRegex = "^[0-9]{8}$";

export const dateRegex = "^[0-9]{4}-[0-9]{2}-[0-9]{2}$";

export const timeRegex = "^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}$";

export const passwordRegex = "^.{6}.*$";


// WEBPACK FOOTER //
// ./src/common/src/regexps.js